import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import { filingMachine } from './filing.machine';

export const useFilingRef = () => feature('filing');
export const useFiling = <R>(selector: (snapshot: SnapshotFrom<typeof filingMachine>) => R): R =>
  useFeature('filing', selector);
export const useFilingActions = () => {
  const ref = useFilingRef();
  return {
    open: (input: { clientId: string; rulePackageId: string }) => ref.send({ type: 'filing.open', input }),
    enter: (input: { filingId: string; distributions: number; fiduciaryFees: number; mustDistributeIncome: boolean }) =>
      ref.send({ type: 'filing.enter', input }),
    request: (filingId: string) => ref.send({ type: 'filing.request', input: { filingId } }),
    openDialog: () => ref.send({ type: 'filing.open-dialog' }),
  };
};
